import { render, staticRenderFns } from "./menu-without-roles.vue?vue&type=template&id=0029cea3"
import script from "./menu-without-roles.vue?vue&type=script&lang=ts"
export * from "./menu-without-roles.vue?vue&type=script&lang=ts"
import style0 from "./menu-without-roles.vue?vue&type=style&index=0&id=0029cea3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports